import useGetPreferencesTypes from "features/notifications/hooks/useGetPreferencesTypes";
import { PreferencesRenderType } from "features/notifications/types";

export default function useGetPreferencesOptions() {
  const preferencesTypes = useGetPreferencesTypes();

  const preferencesOptions: PreferencesRenderType = [
    {
      name: "childAssignmentSet",
      types: preferencesTypes,
      description: "When your child is set an assignment"
    },
    {
      name: "childCompletesAssignment",
      types: preferencesTypes,
      description: "When your child completes an assignment"
    },
    {
      name: "parentWeeklyReport",
      types: preferencesTypes,
      description: "When your child's weekly report is ready"
    },
    {
      name: "subscribed",
      types: preferencesTypes,
      description: "Unsubscribe from all notifications"
    }
  ];
  return preferencesOptions;
}
